import http from '@/libs/http'
import router from '@/router'

export default {
  find(id) {
    return http.get(`/cms/api-group/${id}`).then(result => result.data)
  },
  // is a func for list all api group
  listAll(options) {
    const limit = 10
    const params = Object.assign({
      limit,
      sort_by: 'updated_at',
      order: 'desc'
    }, options)
    delete params.page
    return http.get('/cms/api-groups', { params }).then(result => result.data)
  },
  // is a func for find all api group with paging
  findAll(options) {
    const limit = 10
    const params = Object.assign({
      limit,
      offset: (options.page - 1) * limit,
      sort_by: 'updated_at',
      order: 'desc'
    }, options)
    delete params.page
    const result = http.get('/cms/api-groups', { params }).then(result => result.data)
    result.catch(err => {
      if (err.response.data.code === 401) {
        router.push('/user/signin')
      }
    })
    return result
  },
  create(model) {
    return http.post('/cms/api-groups', model).then(result => result.data).catch(error => error)
  },
  update(model) {
    return http.put(`/cms/api-group/${model.id}`, this._clean(model)).then(result => result.data)
  },
  delete(id) {
    return http.delete(`/cms/api-group/${id}`).then(result => result.data)
  },
  _clean(model) {
    const m = Object.assign({}, model)
    delete m.id
    return m
  }
}
